import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';

import { Gateway } from './gateway';

import myGlobals = require('../config');

@Injectable()
export class GatewayService {

  private gatewayUrl = myGlobals.default.BASE_URL + '/gateway/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todos los gateways habilitados para el usuario
  getGateways() {
    return this.http.get(this.gatewayUrl)
      .map((response) => response.json());
  }

  //Obtener un gateway
  getGateway(_id: string): Observable<Gateway> {
    return this.http.get(this.gatewayUrl + _id)
      .map((response) => response.json());
  }

  //Obtener gateways by sucursal
  getGatewaysBySucursal(_id: string) {
    return this.http.get(this.gatewayUrl + "sucursal/" + _id)
      .map((response) => response.json());
  }

  save(gateway: Gateway): Observable<Gateway> {
    if (gateway._id) {
      return this.put(gateway);
    }
    //Seteo estado activo
    gateway.estado = true;
    return this.post(gateway);
  }

  //Desactivar gateway
  delete(gateway: Gateway) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.gatewayUrl}/${gateway._id}`;

    return this.http
      .delete(url, { headers: headers })
      .map((response) => response.json());
  }

  // Agregar nuevo gateway
  private post(gateway: Gateway): Observable<Gateway> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'
    });
    headers.append('dataType', 'json');
    console.log(gateway);
    console.log(JSON.stringify(gateway));
    var gatewayStr = JSON.stringify(gateway);
    return this.http
      .post(this.gatewayUrl, gatewayStr, { headers: headers })
      .map((response) => response.json());
  }

  // Actualizar gateway
  private put(gateway: Gateway) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.gatewayUrl}/${gateway._id}`;

    return this.http
      .put(url, JSON.stringify(gateway), { headers: headers })
      .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/gateway/gateway.service.ts